import {z} from 'zod'

export const EnvironmentName = z.enum(['local', 'dev', 'staging', 'prod'])
export type EnvironmentName = z.infer<typeof EnvironmentName>
